import { useEffect, useState } from "react";

import { useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { isActionOf } from "typesafe-actions";

import { listsQueryKeys } from "app/pages/sales-intelligence/modules/lists/sub-modules/my-list/services/queries/queryKeyFactory";
import type { ShortOpportunityList } from "app/pages/sales-intelligence/modules/lists/types/types";
import ListDeleteModalTracked from "app/pages/sales-intelligence/sub-modules/opportunities/containers/ListDeleteModal/ListDeleteModalTrackedContainer";
import {
    deleteOpportunityListAsync,
    removeOpportunityListAction,
} from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { deleteOpportunityListThunk } from "app/pages/sales-intelligence/sub-modules/opportunities/store/effects";
import { selectOpportunityListDeleting } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";

type Props = {
    list?: Readonly<ShortOpportunityList>;
    onClose: () => void;
    onDeleteSuccess?: () => void;
};

const ListDeleteModalContainer = (props: Props) => {
    const { list, onClose, onDeleteSuccess } = props;
    const dispatch = useDispatch();
    const isBeingDeleted = useSelector(selectOpportunityListDeleting);
    const [isOpen, setIsOpen] = useState(false);
    const queryClient = useQueryClient();

    useEffect(() => {
        setIsOpen(typeof list !== "undefined");
    }, [list]);

    async function handleDeleteSubmit(id: string) {
        const resultAction = await dispatch(deleteOpportunityListThunk(id));
        const isSuccessfulAction = isActionOf(deleteOpportunityListAsync.success);

        if (isSuccessfulAction(resultAction)) {
            dispatch(removeOpportunityListAction(id));
            void queryClient.invalidateQueries({ queryKey: listsQueryKeys.allStaticLists() });
            onDeleteSuccess?.();
            onClose();
        }
    }

    return (
        <ListDeleteModalTracked
            list={list}
            isOpen={isOpen}
            isBeingSubmitted={isBeingDeleted}
            onCancel={onClose}
            onSubmit={handleDeleteSubmit}
        />
    );
};

export default ListDeleteModalContainer;
